<template>
  <div class="home">
    <ShowAccess/>
  </div>
</template>

<script>
import ShowAccess from '@/components/ShowAccess';

export default {
  name: 'Home',
  components: {
    ShowAccess
  }
}
</script>

<style>
  body {
    margin: 0;
  }
</style>
